import React from "react";
import Footer from "../../Components/Footer/footer";
import { MdOutlineTipsAndUpdates } from "react-icons/md";
import { useSelector } from "react-redux";
import { useState } from "react";
import LineChart from "../Dashbourd/Dashbourd Components/line_chart_tracking";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

const SalesUpdates = () => {
  const store = useSelector((store) => store.login.user);
  const [employee, setEmployee] = useState(
    store &&
      (store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
        store.Role === process.env.REACT_APP_ROLE_ADMIN)
      ? "All"
      : store.Name
  );
  const [leadOwner, setLeadOwner] = useState();
  const [leadsFrom, setLeadsFrom] = useState(30);
  const [leadsData, setLeadsData] = useState();
  const [quotationData, setQuotationData] = useState();

  useEffect(() => {
    performRequest("GET", `/leads/getallleads/`)
      .then((res) => {
        if (res.status === 200) {
          setLeadsData(res?.data?.leads);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [employee]);

  useEffect(() => {
    performRequest("GET", `/quotations/getQuotationsAll/`)
      .then((res) => {
        if (res.status === 200) {
          setQuotationData(res?.data?.quotation);
        } else {
          Toast("error", "Error while getting Quotations!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [employee]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <MdOutlineTipsAndUpdates
                    className="fs-2  me-1"
                    style={{ color: "yellow" }}
                  />{" "}
                  Sales daily updates
                </h2>
                <h4 className="text-muted">Track sales updates.</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                store.Role !== process.env.REACT_APP_ROLE_IT && (
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Sales daily updates</h3>
                        <div className="ms-auto">
                          <div className="d-flex">
                            {store.Role !== process.env.REACT_APP_ROLE_SALLE &&
                              store?.Role !==
                                process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                              store.Role !==
                                process.env.REACT_APP_ROLE_SALESAGENCY && (
                                <div className="me-2">
                                  <div className="dropdown">
                                    <a
                                      className="dropdown-toggle text-muted"
                                      href="/"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      {employee}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <span
                                        onClick={() => setEmployee("All")}
                                        className="dropdown-item"
                                      >
                                        All
                                      </span>
                                      {leadOwner &&
                                        leadOwner.map((data, index) => {
                                          return (
                                            <span
                                              key={index}
                                              onClick={() =>
                                                setEmployee(data.userName)
                                              }
                                              className="dropdown-item"
                                            >
                                              {data?.userName}
                                            </span>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="dropdown">
                              <a
                                className="dropdown-toggle text-muted"
                                href="/"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                Last {leadsFrom || 30} days
                              </a>
                              <div className="dropdown-menu dropdown-menu-end">
                                <span
                                  onClick={() => setLeadsFrom(7)}
                                  className="dropdown-item"
                                >
                                  Last 7 days
                                </span>
                                <span
                                  onClick={() => setLeadsFrom(30)}
                                  className="dropdown-item"
                                >
                                  Last 30 days
                                </span>
                                <span
                                  onClick={() => setLeadsFrom(45)}
                                  className="dropdown-item"
                                >
                                  Last 45 days
                                </span>
                                <span
                                  onClick={() => setLeadsFrom(60)}
                                  className="dropdown-item"
                                >
                                  Last 2 months
                                </span>
                                <span
                                  onClick={() => setLeadsFrom(90)}
                                  className="dropdown-item"
                                >
                                  Last 3 months
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {leadsData &&
                        quotationData &&
                        quotationData.length > 0 &&
                        leadsData.length > 0 && (
                          <LineChart
                            leadsData={leadsData}
                            quotationData={quotationData}
                            leadsFrom={leadsFrom}
                            employee={employee}
                          />
                        )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default SalesUpdates;

// import React, { useEffect, useState } from "react";
// import Footer from "../../Components/Footer/footer";
// import StepRoutes from "../../Routes/steps_routes";
// import Pagination from "../../Components/layouts/pagination";
// import ButtonWithSVG from "../../Components/layouts/button_with_svg";
// import NurseryBatchTable from "./Nursery Management/nursery_table";
// import getFilteredURL from "../../Components/Functions/filters.getUrl";
// import performRequest from "../../api/request";
// import { Toast } from "../../CustomComponent/toast";
// import DynamicFilterInput from "../../Components/layouts/filter.inpit";

// import { FcStackOfPhotos } from "react-icons/fc";
// import { FaLeaf } from "react-icons/fa6";

// const FarmNurseryManagement = () => {
//   const [loading, setLoading] = useState(false);
//   const [refresh, setRefresh] = useState(false);
//   const [page, setPage] = useState(1);
//   const [showPage, setShowPage] = useState(1);
//   const [data, setData] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [filters, setFilters] = useState({
//     startdate: "",
//     enddate: "",
//     name: "",
//   });
//   useEffect(() => {
//     setLoading(true);
//     performRequest(
//       "GET",
//       getFilteredURL("/nurseryManagement/getNurseryManagement", page, filters)
//     )
//       .then((res) => {
//         if (res.status === 200) {
//           setData(res.data);
//           setTotalPages(Math.ceil(res.data.nurseryManagementCount / 50));
//         } else {
//           Toast("error", "Error while getting Attendance!");
//         }
//       })
//       .catch((err) => {
//         Toast("error", "Server Error!");
//         console.error(err);
//       })
//       .finally(() => setLoading(false));
//   }, [refresh, page]);

//   return (
//     <div className="page">
//       <div className="page-wrapper">
//         <div className="container-xxl">
//           <div className="page-header d-print-none">
//             <div className="row align-items-center">
//               <div className="col-md-8">
//                 <h2 className="page-title mb-1">
//                   <FcStackOfPhotos className="fs-2  me-1" /> Nursery Management
//                 </h2>
//                 <h4 className="text-muted">
//                   {/* <StepRoutes /> */} Track & manage your nursery.
//                 </h4>
//               </div>
//               <div className="col-md-4">
//                 <div className="btn-list justify-content-end">
//                   <a
//                     href={"/farm-nursery-management/new-batch"}
//                     className="btn btn-primary"
//                   >
//                     {" "}
//                     <FaLeaf className="fs-3 me-2" /> Start a new batch
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-md-3 col-sm-12 py-2">
//               <div className="card p-1">
//                 <div
//                   id="faq-1"
//                   className="accordion"
//                   role="tablist"
//                   aria-multiselectable="true"
//                 >
//                   <div>
//                     <div className="accordion-header m-0" role="tab">
//                       <button
//                         className="accordion-button fs-3 d-md-none"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#faq-1-1"
//                       >
//                         <h3>Filter result</h3>
//                       </button>
//                     </div>

//                     <div
//                       id="faq-1-1"
//                       className="accordion-collapse collapse d-md-none"
//                       role="tabpanel"
//                       data-bs-parent="#faq-1"
//                     >
//                       <div className="accordion-body pt-0">
//                         <div className="row">
//                           <div className="col-12">
//                             <DynamicFilterInput
//                               label="Start Date:"
//                               value={filters.startdate}
//                               onChange={(e) =>
//                                 setFilters({
//                                   ...filters,
//                                   startdate: e.target.value,
//                                 })
//                               }
//                               type="date"
//                             />
//                           </div>
//                           <div className="col-12">
//                             <DynamicFilterInput
//                               label="End Date:"
//                               value={filters.enddate}
//                               onChange={(e) =>
//                                 setFilters({
//                                   ...filters,
//                                   enddate: e.target.value,
//                                 })
//                               }
//                               type="date"
//                             />
//                           </div>
//                           <div className="col-12">
//                             <DynamicFilterInput
//                               label="Search batch name:"
//                               value={filters.name}
//                               onChange={(e) =>
//                                 setFilters({ ...filters, name: e.target.value })
//                               }
//                               placeholder="search name..."
//                             />
//                           </div>

//                           <div className="col-12">
//                             <div className="row mt-2">
//                               <div className="col-6">
//                                 <button
//                                   onClick={() => setRefresh(!refresh)}
//                                   className="btn btn-success w-100"
//                                 >
//                                   Apply Filter
//                                 </button>
//                               </div>
//                               <div className="col-6">
//                                 <button
//                                   onClick={() => {
//                                     setFilters({
//                                       startdate: "",
//                                       enddate: "",
//                                       contactname: "",
//                                       quotationtype: "",
//                                     });
//                                     setRefresh(!refresh);
//                                   }}
//                                   className="btn btn-secondary w-100"
//                                 >
//                                   Reset Filter
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="accordion-body d-none d-md-block">
//                       <div className="row">
//                         <h3>Filter result</h3>
//                         <div className="col-12">
//                           <DynamicFilterInput
//                             label="Start Date:"
//                             value={filters.startdate}
//                             onChange={(e) =>
//                               setFilters({
//                                 ...filters,
//                                 startdate: e.target.value,
//                               })
//                             }
//                             type="date"
//                           />
//                         </div>
//                         <div className="col-12">
//                           <DynamicFilterInput
//                             label="End Date:"
//                             value={filters.enddate}
//                             onChange={(e) =>
//                               setFilters({
//                                 ...filters,
//                                 enddate: e.target.value,
//                               })
//                             }
//                             type="date"
//                           />
//                         </div>
//                         <div className="col-12">
//                           <DynamicFilterInput
//                             label="Search batch name:"
//                             value={filters.name}
//                             onChange={(e) =>
//                               setFilters({ ...filters, name: e.target.value })
//                             }
//                             placeholder="search name..."
//                           />
//                         </div>

//                         <div className="col-12">
//                           <div className="row mt-2">
//                             <div className="col-6">
//                               <button
//                                 onClick={() => setRefresh(!refresh)}
//                                 className="btn btn-success w-100"
//                               >
//                                 Apply Filter
//                               </button>
//                             </div>
//                             <div className="col-6">
//                               <button
//                                 onClick={() => {
//                                   setFilters({
//                                     startdate: "",
//                                     enddate: "",
//                                     contactname: "",
//                                     quotationtype: "",
//                                   });
//                                   setRefresh(!refresh);
//                                 }}
//                                 className="btn btn-secondary w-100"
//                               >
//                                 Reset Filter
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-9 col-sm-12 py-2">
//               <div className="card">
//                 {data && data?.nurseryManagementData && (
//                   <NurseryBatchTable
//                     BatchData={data?.nurseryManagementData}
//                     currentPage={page}
//                     itemsPerPage={50}
//                   />
//                 )}
//                 <Pagination
//                   page={page}
//                   setPage={setPage}
//                   totalPages={totalPages}
//                   pageDatalength={data?.nurseryManagementData?.length}
//                   showPage={showPage}
//                   setShowPage={setShowPage}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default FarmNurseryManagement;
